/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { intlShape } from "../../shapes";
import { AlertType } from "../../constants";
import { isNotEmpty } from "../../utils";
import { withIntl } from "../../wrappers";

function getIconClassName(type: $TSFixMe) {
  switch (type) {
    case AlertType.SUCCESS:
      return "icon icon3-eh-radio-button-checked text-success";
    case AlertType.INFO:
      return "icon lcm-iot-icon-info text-info";
    case AlertType.WARNING:
      return "icon icon-eh-warning-1 text-warning";
    default:
      return "icon icon-eh-warning-1 text-danger";
  }
}

type Props = {
  className?: string;
  type?: string;
  message?: string;
  children?: React.ReactNode;
  dataTestId?: string | null;
  intl: intlShape;
};

export function InputAlert({
  children,
  message,
  intl,
  className,
  dataTestId = null,
  type,
}: Props) {
  const [extendedMessageVisible, setExtendedMessageVisible] = useState(false);

  if (isNotEmpty(message)) {
    if (children) {
      const detailsLink = extendedMessageVisible
        ? intl.formatMessage({ id: "global.hide_details" })
        : intl.formatMessage({ id: "global.show_details" });
      const details = extendedMessageVisible ? children : null;
      return (
        <div
          id="input-alert"
          data-testid={dataTestId}
          className={`input-alert ${className || ""}`}
        >
          <small>
            <span className={getIconClassName(type)} />
            <span>
              {message}
              {" ("}
              <a
                id="show-error-details"
                onClick={() =>
                  setExtendedMessageVisible(!extendedMessageVisible)
                }
              >
                {detailsLink}
              </a>
              )
            </span>
            {details}
          </small>
        </div>
      );
    }
    return (
      <div
        data-testid={dataTestId}
        className={`input-alert ${className || ""}`}
      >
        <small>
          <span className={getIconClassName(type)} />
          <span>{` ${message}`}</span>
        </small>
      </div>
    );
  }
  return null;
}

export default withIntl(InputAlert);
